import React from "react";
import type { AssistantMediaPart } from "../../../chat/types";
import { AnimatedCard } from "../../Common/AnimatedCard";

export function MediaAudioCard({ part }: { part: AssistantMediaPart }) {
  return (
    <AnimatedCard variant="sm" sx={{ p: 1, my: 1 }}>
      <audio src={part.url} controls aria-label={part.alt} style={{ width: "100%" }} />
    </AnimatedCard>
  );
}
